import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import './index.css';
import { GoogleOAuthProvider } from '@react-oauth/google';
import App from './App';

// Definisci le variabili d'ambiente globali
window.ENV = {
    apiUrl: 'http://localhost:3001/api',
    wsUrl: 'ws://localhost:3001/ws',
    googleClientId: '379964937752-n3ib70th3j0f308c6a5etbq894kogupk.apps.googleusercontent.com',
    environment: 'development'
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <GoogleOAuthProvider clientId={window.ENV.googleClientId}>
            <App />
        </GoogleOAuthProvider>
    </React.StrictMode>
);
